import { Injectable } from '@angular/core';
import { AboutCourtFeesItemApisModel } from '../../models/about-court-fee/about-court-fees';
import { RequestItemApisModel } from '../../models/request/request';
import { AccuseritemModel } from '../../view-models/conferencing';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class AboutCourtFeesItemMapper implements Mapper<AboutCourtFeesItemApisModel, AccuseritemModel>  {
    constructor(
    ) { }
    mapForm(param: AboutCourtFeesItemApisModel): AccuseritemModel {
        return null!
    }

    mapTo(param: AccuseritemModel): AboutCourtFeesItemApisModel {
        return {
            accId: param.acC_ID,
            groupId: param.grouP_ID
        }
    }
} 